import { Grid } from '@material-ui/core';
import React, { useMemo } from 'react';
import { DetailsCell } from '../Devices/components/DevicesTable/tableComponents';
import { TableColumn } from '../../components/InfiniteTable/types';
import { SortOption, SortState } from '../../utils/sort';
import { MedisanteDevice, SensorsSortBy } from './types';

export const useSensorsTableColumns = (
  sortState: SortState<MedisanteDevice>,
  updateSortState: React.Dispatch<SortOption<SensorsSortBy>>
): TableColumn<MedisanteDevice>[] => {
  const columns = useMemo(() => {
    const tableColumns: TableColumn<MedisanteDevice>[] = [];

    tableColumns.push({
      header: 'Serial Number',
      name: 'serialNumber',
      width: 'auto',
      sortState: sortState.serialNumber,
      onHeaderClick: () =>
        updateSortState({ sortBy: SensorsSortBy.SERIAL_NUMBER }),
    });

    tableColumns.push({
      header: 'Model',
      name: 'model',
      width: 'auto',
      sortState: sortState.model,
      onHeaderClick: () => updateSortState({ sortBy: SensorsSortBy.MODEL }),
    });

    tableColumns.push({
      header: 'MAC Address',
      name: 'mac',
      cell: (sensor) => <>{sensor.mac || '-'}</>,
      width: 'auto',
      sortState: sortState.mac,
      onHeaderClick: () => updateSortState({ sortBy: SensorsSortBy.MAC }),
    });

    tableColumns.push({
      header: 'Measurements',
      name: 'measurementCount',
      width: 'auto',
      sortState: sortState.measurementCount,
      onHeaderClick: () =>
        updateSortState({ sortBy: SensorsSortBy.MEASUREMENTS }),
    });

    tableColumns.push({
      name: '',
      header: '',
      cell: (device: MedisanteDevice) => (
        <Grid container justifyContent="flex-end">
          <DetailsCell device={device} />
        </Grid>
      ),
      width: 'auto',
    });

    return tableColumns;
  }, [sortState, updateSortState]);

  return columns;
};
